import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { TextField } from "@material-ui/core";
import { Translation } from "react-i18next";
import { Button, Popover, PopoverHeader, PopoverBody } from "reactstrap";
import { connect } from "react-redux";
import { setCORS } from "google-translate-api-browser";
import { getServiceTypeList } from "../Actions/CommonAPI";
import MMPLShipCard from "./MMPLShipCard";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DatePicker from "react-datepicker";
import FileSaver from "file-saver";
import Moment from "moment";
import { getMDSearchlist } from "../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import {
  getShipSearchlist,
  getMMPLShipCount,
  getMMPLShipDeatil,
  exportToExcel,
} from "../Actions/MMPLDashboardAPI";
import CountUp from "react-countup";
import { AutoComplete } from "primereact/autocomplete";
import { Multiselect } from "multiselect-react-dropdown";
import MapCharts from "./Mapchart";
import axios from "axios";
import API from "../helpers/api";
import moment from "moment";
import $, { uniqueSort } from "jquery";
import AddIcon from "../UIComponents/AddIcon";
import DoneIcon from "../Asset/done-icon.png";
import { Tabs, Tab } from 'react-bootstrap';
// import CloseIcon from "../Asset/close-icon.png";
import { toast } from "react-toastify";
/* import {
  getShipPortAndCountry,
} from "../Actions/ServiceProviderAPI";
import {
  getShipEquipmentSearchlist
} from "../Actions/ShipEquipmentDetailsAPI";
import { getShipEquipmentAndCategoryList } from "../Actions/helpersAPI"; */

let userrole = localStorage.getItem("UserRoles");
class MMPLDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedRadio: 0,
      SelectedLang: "",
      SelectedFromDate: "",
      SelectedToDate: "",
      fromDate: "",
      allShipo: 100,
      expiredShips: 99,
      expiringShips: 50,
      toDate: "",
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      filterTitle: "All Ships",
      action: 1,
      portValue: [],
      clientList: [],
      originalPortData: {},
      markers: [],
      searchShip: {
        IsClient: false,
        shipName: "",
        category: "",
        imoNo: "",
        client: "",
        serviceStatus: "",
        nextServiceDateFrom: "",
        nextServiceDateTo: "",
        pagesize: 25,
        pagenumber: 1,
        noofrecords: 2,
        ServiceTypes: [],
        isTotalShips: true,
        isOverdueShips: false,
        isShipsDue10: false,
        isShipsDue30: false,
        isShipsDue60: false,
        isShipsDue90: false,
        action: 1,
        status: "active",
        isShipSearch: false,
        isShoreSearch: false,
        FilterByIsInContract: ""
      },
      shipData: {
        IsClient: false,
        mail: "",
        shipName: "",
      },
      inContract: false,
      notInContract: false,
      isBoth: true,
      isPopoveropen: false,
      selectedServiceTypes: [],
      EquipmentList: ["A_Equipment1", "B_Equipment2", "C_Equipment"],
      serviceType: [],
      PageNo: 1,
      tabs: [
        {
          tabName: "New",
          unique_id: `new1${(Math.random() + 1).toString(36).substring(7)}`,
          summernoteData: "",
          showInput: false
        }
      ],
      initialTabs: [
        {
          tabName: "New",
          unique_id: `new1${(Math.random() + 1).toString(36).substring(7)}`,
          summernoteData: "",
          showInput: false
        }
      ],
      deleteTabId: 0,
      deleteUniqueId: 0,
      currentTab: "All",
      /* port: "",
      country: "",
      equipmentServiceDetails: {
        equipmentServicePlanId: 0, // uniques identifier
        shipId: 0,
        shipEquipmentId: 0,
        serviceType: null, //string,
        nextServicePerformedBy: null, //string,
        nextDue: "", // date
        portId: 0,
        port: null, //string,
        countryId: 0,
        country: null, //string,
        comments: null, //string
      },
      searchEquipment: {
        equipment: "",
        category: "",
        next_due_in_from: "",
        next_due_in_to: "",
        pagesize: 25,
        pagenumber: 1,
        ServiceTypes: [],
        status: "",
        shipId: "",
        isTotalShips: true,
        isOverdueShips: false,
        isShipsDue10: false,
        isShipsDue30: false,
        isShipsDue60: false,
        isShipsDue90: false,
      },
      equipmentServiceShipId: NaN */
    };
    this.multiSelectRef = React.createRef()
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openToDatePicker = this.openToDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.GenerateReportData = this.GenerateReportData.bind(this);
    this.SearchMMPLData = this.SearchMMPLData.bind(this);
    this.ClearSearchField = this.ClearSearchField.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleChangeClientName = this.handleChangeClientName.bind(this);
    this.handleChangeEquipmentName = this.handleChangeEquipmentName.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleRemoveChange = this.handleRemoveChange.bind(this);
  }

  componentDidMount() {
    // window["summernote_addEditDesc"]();
    const { dispatch, searchData, searched, t } = this.props;
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    dispatch(getServiceTypeList());
    dispatch({
      type: "SubBannerTitle",
      data: "Dashboard",
    });
    let BothResult = localStorage.getItem("SearchBothContract");
    let ContractResult = localStorage.getItem("SearchCotract");
    if (BothResult !== "") {
      this.state.isBoth = JSON.parse(BothResult);
    }
    if (ContractResult === "false" && BothResult !== "true") {
      this.state.inContract = JSON.parse(ContractResult);
      this.state.notInContract = true;
    } else if (ContractResult !== "") {
      this.state.inContract = JSON.parse(ContractResult);
    }

    this.setState({}, () => {
      // console.log(this.state.inContract,this.state.notInContract,this.state.isBoth)
    })
    let countVal = '';
    let filterAll = true;
    const filterKeys = [
      "isOverdueShips",
      "isShipSearch",
      "isShipsDue10",
      "isShipsDue30",
      "isShipsDue60",
      "isShipsDue90"
    ];
    if (searchData) {
      filterAll = !filterKeys.some(key => searchData[key] === true);
      if (searchData.FilterByIsInContract === true) {
        this.state.currentTab = "contract"
        countVal = true;
      }
      if (searchData.FilterByIsInContract === false) {
        this.state.currentTab = "nonContract"
        countVal = false;
      }
      if (searchData.FilterByIsInContract === "") {
        this.state.currentTab = "All"
        countVal = "";
      }
      this.state.searchShip = searchData;
      this.state.searchShip.status = "active";
      if (searchData.ServiceTypes != "") {
        this.state.selectedServiceTypes = searchData.ServiceTypes.split(",");
      }
      // if (searched !== true) {
      //   this.ClearSearchField("cardClick");
      //   // dispatch({ type: "searchData", data: "" });
      // }
    }
    this.setState({});
    dispatch(getMMPLShipCount(this.state.inContract, this.state.isBoth, countVal));
    dispatch(getShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth, filterAll == true ? true : false));
    // dispatch(getServiceTypeList()); 
    /* dispatch(getShipPortAndCountry({
      port: "",
      country: "",
      serviceProvider: "",
    })); */
    this.getClientList();
    this.getMapInfo(this.state.inContract, this.state.isBoth);
    /* this.getPortInfo(); */
    dispatch({ type: "searched", data: false });
    let searchitem = this.state.searchShip;
    let _this = this;
    // $(document).keypress(function (event) {
    //   var keycode = event.keyCode || event.which;
    //   if (
    //     searchitem.shipName ||
    //     searchitem.client ||
    //     searchitem.imoNo ||
    //     searchitem.ServiceTypes.length > 0 ||
    //     searchitem.nextServiceDateFrom ||
    //     searchitem.nextServiceDateTo
    //   ) {
    //     if (keycode === 13) {
    //       _this.SearchMMPLData(1, 2,true);
    //     }
    //   }
    // });
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;

      if (keycode === 13) {
        if (_this.verify()) {
          _this.SearchMMPLData(1, 2, true);
        }
        else {

          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }

    }
    $(document).keypress(this.keyPressHandler);
    $(document).on("click", ".equipment-service-pop-up-trigger", function () {
      var shipId = $(this).attr("data-shipId");
      _this.setState({
        equipmentServiceShipId: parseInt(shipId),
      }, () => {
        if (_this.state.equipmentServiceShipId) {
          _this.getShipNotes();
        }
        // dispatch(getShipEquipmentAndCategoryList({ EquipmentName: '', shipId: _this.state.equipmentServiceShipId, Category: '' }));
      });
    })

    $(document).on("blur", ".nav-tab-input", function () {
      let _tabs = _this.state.tabs;
      _tabs.forEach(ele => {
        ele['showInput'] = false;
      });
      _this.setState({
        tabs: _tabs
      });
    })

    // document.addEventListener("click", (evt) => {
    //   const flyoutEl = document.getElementById("map");
    //   let targetEl = evt.target; // clicked element
    //   do {
    //     if(targetEl == flyoutEl) {
    //       // This is a click inside, does nothing, just return.
    //       alert("Clicked inside!");
    //       return;
    //     }
    //     targetEl = targetEl.parentNode;
    //   } while (targetEl);
    //   // this.props.dispatch({ type: "MapPopup", data: "close" });
    //   alert("Clicked outside!");
    // });
  }

  componentWillUnmount() {
    $(document).off("keypress", this.keyPressHandler);
    this.setState({
      searchShip: {
        IsClient: false,
        shipName: "",
        category: "",
        imoNo: "",
        client: "",
        serviceStatus: "",
        nextServiceDateFrom: "",
        nextServiceDateTo: "",
        pagesize: 25,
        pagenumber: 1,
        noofrecords: 2,
        ServiceTypes: [],
        isTotalShips: true,
        isOverdueShips: false,
        isShipsDue10: false,
        isShipsDue30: false,
        isShipsDue60: false,
        isShipsDue90: false,
        action: 1,
        status: "active",
        isShipSearch: false,
        isShoreSearch: false,
        FilterByIsInContract: ""
      }
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, shipSearchResult, mmplShipCount } = nextProps;
    if (nextProps.isMDSearch && nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
    }
    if (nextProps.MDDeleteSuccess && !nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
      dispatch(getMDSearchlist(prevState.searchShip));
    }
    /* if (shipSearchResult) {
      console.log(shipSearchResult)
    }
    if (CountryList?.data?.length) {
      let uniqueCountry = [...new Map(CountryList.data.map(item => [item['country'], item])).values()];
      prevState.countryList = uniqueCountry;
    }
     if (PortList?.data?.length) {
      let uniquePort = [...new Map(PortList.data.map(item => [item['port'], item])).values()];
      prevState.portList = uniquePort;
    }

    if (ServiceProviderPortList?.data?.length) {
      console.log(ServiceProviderPortList);
    }
   if (EquipmentNameList.length) {
      console.log(EquipmentNameList)
    } */
  }


  toggle = (target, item) => {
    this.state.inContract = this.state.inContract;
    this.state.isBoth = this.state.isBoth;
    this.state.notInContract = this.state.notInContract;
    this.state.isPopoveropen = !this.state.isPopoveropen;
    this.setState({
    });
  };
  // handleRadioButtonChange = (e) => {
  //   let nodeName = e.target.name;
  //   if (nodeName === "incontract") {
  //     this.state.inContract = true;
  //     this.state.notInContract = false;
  //     this.state.isBoth = false;
  //   }
  //   if (nodeName === "notcontract") {
  //     this.state.inContract = false;
  //     this.state.notInContract = true;
  //     this.state.isBoth = false;
  //   }
  //   if (nodeName === "both") {
  //     this.state.inContract = false;
  //     this.state.notInContract = false;
  //     this.state.isBoth = true;
  //   }
  //   this.setState({});
  // };

  handleRadioButtonChange = (e) => {
    const { name } = e.target;

    let selectedRadioValue;

    switch (name) {
      case "incontract":
        selectedRadioValue = 1;
        break;
      case "notcontract":
        selectedRadioValue = 2;
        break;
      case "both":
        selectedRadioValue = 0;
        break;
      default:
        return;
    }

    this.setState({
      SelectedRadio: selectedRadioValue,
    },
      console.log(this.state.SelectedRadio, 'radio')
    );
  };



  submitRequest = () => {
    const { dispatch } = this.props;
    localStorage.setItem("SearchCotract", this.state.inContract)
    localStorage.setItem("SearchBothContract", this.state.isBoth)
    if (this.state.SelectedRadio === 0)
      this.getShipDetails(1);
    else if (this.state.SelectedRadio === 1)
      this.getShipDetails(7, false, false);
    else if (this.state.SelectedRadio === 2)
      this.getShipDetails(8, false, false);
    // dispatch(getMMPLShipCount(this.state.inContract, this.state.isBoth));
    // dispatch(getShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth, true));
    // this.getMapInfo(this.state.inContract, this.state.isBoth)
    this.state.isPopoveropen = !this.state.isPopoveropen;
    this.setState({})
  };

  selectGetShipDetails = () => {
    if (this.state.searchShip.FilterByIsInContract == true) {
      this.getShipDetails(7, false, false);
    }
    else if (this.state.searchShip.FilterByIsInContract == false && this.state.searchShip.FilterByIsInContract !== '') {
      this.getShipDetails(8, false, false);
    }
    else {
      this.getShipDetails(1)
    }
  }

  getShipDetails(action, isShipSearch = false, isShoreSearch = false) {
    const { dispatch } = this.props;
    // this.setState({ markers: [] })

    if (action === 1) {
      this.state.filterTitle = "All Ships";
      this.state.searchShip.isTotalShips = true;
      this.state.searchShip.FilterByIsInContract = '';
      this.state.searchShip.isOverdueShips = false;
      this.state.searchShip.isShipsDue10 = false;
      this.state.searchShip.isShipsDue30 = false;
      this.state.searchShip.isShipsDue60 = false;
      this.state.searchShip.isShipsDue90 = false;
      this.setState({ action: 1 }, () => {
        this.SearchMMPLData(1, 2, true);
        this.ClearSearchField("cardClick");
        this.props.dispatch(getMMPLShipCount(this.state.inContract, this.state.isBoth, ''));

      });
    } else if (action === 2) {
      this.state.filterTitle = "Overdue Ships";
      // this.state.searchShip.isTotalShips = false;
      // this.state.searchShip.FilterByIsInContract = "";
      this.state.searchShip.isOverdueShips = true;
      this.state.searchShip.isShipsDue10 = false;
      this.state.searchShip.isShipsDue30 = false;
      this.state.searchShip.isShipsDue60 = false;
      this.state.searchShip.isShipsDue90 = false;
      this.state.searchShip.isShipSearch = isShipSearch;
      this.state.searchShip.isShoreSearch = isShoreSearch;
      this.setState({ action: 2 }, () => {
        this.SearchMMPLData(1, 2, false);
        this.ClearSearchField("cardClick");
      });
    } else if (action === 3) {
      this.state.filterTitle = "Ships Due in 10 Days";
      // this.state.searchShip.isTotalShips = false;
      // this.state.searchShip.FilterByIsInContract = "";
      this.state.searchShip.isOverdueShips = false;
      this.state.searchShip.isShipsDue10 = true;
      this.state.searchShip.isShipsDue30 = false;
      this.state.searchShip.isShipsDue60 = false;
      this.state.searchShip.isShipsDue90 = false;
      this.state.searchShip.isShipSearch = isShipSearch;
      this.state.searchShip.isShoreSearch = isShoreSearch;
      this.setState({ action: 3 }, () => {
        this.SearchMMPLData(1, 2, false);
        this.ClearSearchField("cardClick");
      });
    } else if (action === 4) {
      this.state.filterTitle = "Ships Due in 30 Days";
      // this.state.searchShip.isTotalShips = false;
      // this.state.searchShip.FilterByIsInContract = "";
      this.state.searchShip.isOverdueShips = false;
      this.state.searchShip.isShipsDue10 = false;
      this.state.searchShip.isShipsDue30 = true;
      this.state.searchShip.isShipsDue60 = false;
      this.state.searchShip.isShipsDue90 = false;
      this.state.searchShip.isShipSearch = isShipSearch;
      this.state.searchShip.isShoreSearch = isShoreSearch;
      this.setState({ action: 4 }, () => {
        this.SearchMMPLData(1, 2, false);
        this.ClearSearchField("cardClick");
      });
    } else if (action === 5) {
      this.state.filterTitle = "Ships Due in 60 Days";
      // this.state.searchShip.isTotalShips = false;
      // this.state.searchShip.FilterByIsInContract = "";
      this.state.searchShip.isOverdueShips = false;
      this.state.searchShip.isShipsDue10 = false;
      this.state.searchShip.isShipsDue30 = false;
      this.state.searchShip.isShipsDue60 = true;
      this.state.searchShip.isShipsDue90 = false;
      this.state.searchShip.isShipSearch = isShipSearch;
      this.state.searchShip.isShoreSearch = isShoreSearch;
      this.setState({ action: 5 }, () => {
        this.SearchMMPLData(1, 2, false);
        this.ClearSearchField("cardClick");
      });
    } else if (action === 6) {
      this.state.filterTitle = "Ships Due in 90 Days";
      // this.state.searchShip.isTotalShips = false;
      // this.state.searchShip.FilterByIsInContract = "";
      this.state.searchShip.isOverdueShips = false;
      this.state.searchShip.isShipsDue10 = false;
      this.state.searchShip.isShipsDue30 = false;
      this.state.searchShip.isShipsDue60 = false;
      this.state.searchShip.isShipsDue90 = true;
      this.state.searchShip.isShipSearch = isShipSearch;
      this.state.searchShip.isShoreSearch = isShoreSearch;
      this.setState({ action: 6 }, () => {
        this.SearchMMPLData(1, 2, false);
        this.ClearSearchField("cardClick");
      });
    } else if (action === 7) {
      this.state.filterTitle = "Contract Ships";
      this.state.searchShip.isTotalShips = true;
      this.state.searchShip.FilterByIsInContract = true;
      this.state.searchShip.isOverdueShips = false;
      this.state.searchShip.isShipsDue10 = false;
      this.state.searchShip.isShipsDue30 = false;
      this.state.searchShip.isShipsDue60 = false;
      this.state.searchShip.isShipsDue90 = false;
      this.state.searchShip.isShipSearch = isShipSearch;
      this.state.searchShip.isShoreSearch = isShoreSearch;
      // this.state.inContract = false;
      // this.state.isBoth = true;
      this.setState({ action: 7 }, () => {
        this.SearchMMPLData(1, 2, true);
        this.ClearSearchField("cardClick");
        this.props.dispatch(getMMPLShipCount(false, true, true));
      });
    } else if (action === 8) {
      this.state.filterTitle = "Non Contract Ships";
      this.state.searchShip.isTotalShips = true;
      this.state.searchShip.FilterByIsInContract = false;
      this.state.searchShip.isOverdueShips = false;
      this.state.searchShip.isShipsDue10 = false;
      this.state.searchShip.isShipsDue30 = false;
      this.state.searchShip.isShipsDue60 = false;
      this.state.searchShip.isShipsDue90 = false;
      this.state.searchShip.isShipSearch = isShipSearch;
      this.state.searchShip.isShoreSearch = isShoreSearch;
      // this.state.inContract = false;
      // this.state.isBoth = true;
      this.setState({ action: 8 }, () => {
        this.SearchMMPLData(1, 2, true);
        this.ClearSearchField("cardClick");
        this.props.dispatch(getMMPLShipCount(false, true, false));
      });
    }
    this.getMapInfo(this.state.inContract, this.state.isBoth);
  }

  handleFromDateChange(date) {
    this.state.searchShip.nextServiceDateFrom = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
  }


  handleToDateChange(date) {
    this.state.searchShip.nextServiceDateTo = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false,
    });
  }

  openFromDatePicker() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }

  openToDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  }

  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }
  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchShip[nodeName] = e.target.value;
    this.setState({});
  }

  /*  handleInputChange(e) {
     let _this = this;
     let searchValue="";
     let EnglishValue="";
     let SelectLanguage = localStorage.getItem("SelectedLanguage");
     let nodeName = e.target.name;
     if(e.target.value.length ===1){
      searchValue = e.target.value;
     }else{
       var str = e.target.value;
       var res = str.charAt(str.length-1);
       EnglishValue=this.state.searchShip[nodeName];
        searchValue =EnglishValue+res;
     }
    
     if (SelectLanguage === "en") {
       _this.state.searchShip[nodeName] = searchValue;
       _this.setState({});
     } else if (SelectLanguage === "ja") {
       var url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=ja&dt=t&q=${searchValue}`;
       $.post(url, function (data, status) {
         _this.state.searchShipJapanese[nodeName] = data[0][0][0];
         _this.state.searchShip[nodeName]=data[0][0][1];
         _this.setState({});
       });
      
         } else if (SelectLanguage === "ko") {
       var url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=ko&dt=t&q=${searchValue}`;
       $.post(url, function (data, status) {
         _this.state.searchShipKorean[nodeName] = data[0][0][0];
         _this.state.searchShip[nodeName]=data[0][0][1];
         _this.setState({});
       });
    
      
     }
   } */
  serviceTypeChange(item, e) {
    let checked = [];
    checked = this.state.serviceType;
    if (e.target.checked) {
      checked.push({
        checkboxValue: item,
      });
      if (item === "Annual") {
        this.state.searchShip.Annually = true;
      } else if (item === "Biannual") {
        this.state.searchShip.Biannually = true;
      } else if (item === "Five yearly") {
        this.state.searchShip.FiveYearly = true;
      } else if (item === "Ten yearly") {
        this.state.searchShip.Tenyearly = true;
      }
    } else {
      const index = checked.findIndex((ch) => ch.checkboxValue === item);
      checked.splice(index, 1);
      if (item === "Annual") {
        this.state.searchShip.Annually = false;
      } else if (item === "Biannual") {
        this.state.searchShip.Biannually = false;
      } else if (item === "Five yearly") {
        this.state.searchShip.FiveYearly = false;
      } else if (item === "Ten yearly") {
        this.state.searchShip.Tenyearly = false;
      }
    }
    this.setState({ serviceType: checked });
    this.setState({});
  }

  suggestMItable(event) {
    let results = this.state.EquipmentList.filter((table) => {
      return table.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });

    this.setState({ EquipmentList: results });
  }

  /* Client Auto completed field function */
  handleChangeClientName(event, value) {
    this.setState({
      searchShip: {
        ...this.state.searchShip,
        client: value,
      }
    });
  };

  handleChangeEquipmentName(event, value) {
    let equipmentName = value.equipmentName;
    if (equipmentName) {

    }
  }

  GenerateReportData(contract, both, FilterByIsInContract) {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let URL = `${API.ShipReportAPI}?FilterByIsInContract=${FilterByIsInContract ?? ""}&IsClient=${this.state.searchShip.IsClient}&Mail=${user.email}&FliterByTotalShips=${this.state.searchShip.isTotalShips}&status=${this.state.searchShip.status}&FliterByOverDue=${this.state.searchShip.isOverdueShips}&MMPLFliterByDueIn10Days=${this.state.searchShip.isShipsDue10}&FliterByDueIn30Days=${this.state.searchShip.isShipsDue30}&MMPLFliterByDueIn60Days=${this.state.searchShip.isShipsDue60}&FliterByDueIn90Days=${this.state.searchShip.isShipsDue90}&ShipName=${this.state.searchShip.shipName}&imo=${this.state.searchShip.imoNo}&MmplClientName=${this.state.searchShip.client}&MmplCategoryName=${this.state.searchShip.category}&ServiceTypes=${this.state.searchShip.ServiceTypes}&NextDueInFromDate=${this.state.searchShip.nextServiceDateFrom}&NextDueInToDate=${this.state.searchShip.nextServiceDateTo}&inContract=${contract}&isBoth=${FilterByIsInContract === "" ? true : false}&PageNumber=${this.state.searchShip.pagenumber}&PageSize=${this.state.searchShip.pagesize}`;
    axios
      .get(URL, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });

        if (this.state.searchShip.isOverdueShips === true) {
          FileSaver.saveAs(
            blob,
            "Overdue ship report" + moment().format("DD MM YYYY LT") + ".xlsx"
          );
        } else if (this.state.searchShip.isShipsDue10 === true) {
          FileSaver.saveAs(
            blob,
            "Shipdue10 report" +
            " " +
            moment().format("DD MM YYYY LT") +
            ".xlsx"
          );
        } else if (this.state.searchShip.isShipsDue30 === true) {
          FileSaver.saveAs(
            blob,
            "Shipdue30 report" +
            " " +
            moment().format("DD MM YYYY LT") +
            ".xlsx"
          );
        } else if (this.state.searchShip.isShipsDue60 === true) {
          FileSaver.saveAs(
            blob,
            "Shipdue60 report" +
            " " +
            moment().format("DD MM YYYY LT") +
            ".xlsx"
          );
        } else if (this.state.searchShip.isShipsDue90 === true) {
          FileSaver.saveAs(
            blob,
            "Shipdue90 report" +
            " " +
            moment().format("DD MM YYYY LT") +
            ".xlsx"
          );
        }
        else if (this.state.searchShip.isTotalShips === true) {
          FileSaver.saveAs(
            blob,
            "Ship report" + moment().format("DD MM YYYY LT") + ".xlsx"
          );
        }
        else if (this.state.searchShip.FilterByIsInContract === true) {
          FileSaver.saveAs(
            blob,
            "Contract ship report" + moment().format("DD MM YYYY LT") + ".xlsx"
          );
        }
        else if (this.state.searchShip.FilterByIsInContract === false) {
          FileSaver.saveAs(
            blob,
            "Non Contract ship report" + moment().format("DD MM YYYY LT") + ".xlsx"
          );
        }
        else {
          FileSaver.saveAs(
            blob,
            "Ship report" + moment().format("DD MM YYYY LT") + ".xlsx"
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  verify = () => {
    const { shipName, imoNo, client, nextServiceDateFrom, nextServiceDateTo, pagenumber } = this.state.searchShip
    const { selectedServiceTypes } = this.state
    if (shipName == "" && imoNo == "" && client == "" && nextServiceDateFrom == "" && nextServiceDateTo == "" && selectedServiceTypes == "") {
      return false
    }
    else {
      return true
    }
  }

  searchValidate = (pgno, noof, totalships) => {
    const { t } = this.props;
    if (this.verify()) {
      this.SearchMMPLData(pgno, noof, totalships)
    }
    else {
      // alert('fillz')
      toast.success(t('Toast.Success'), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  PaginateCard(pgno, noof) {
    const filterKeys = [
      "isOverdueShips",
      "isShipSearch",
      "isShipsDue10",
      "isShipsDue30",
      "isShipsDue60",
      "isShipsDue90"
    ];
    let filterAll = true;
    filterAll = !filterKeys.some(key => this.state.searchShip[key] === true);
    this.SearchMMPLData(pgno, noof, filterAll);

  }

  SearchMMPLData(pgno, noof, totalships) {
    const { dispatch } = this.props;
    const { searchShip, selectedServiceTypes } = this.state;

    searchShip["noofrecords"] = noof;
    searchShip["pagenumber"] = pgno;
    searchShip.ServiceTypes = selectedServiceTypes.join(",");
    // if(this.verify()){
    this.setState(
      {
        searchShip: searchShip,
        filterShiplist: true,
      },
      () => {
        dispatch({ type: "searchData", data: this.state.searchShip });
        dispatch(getShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth, totalships));
        this.setState({});
      }
    );
    // }
  }
  // verifysearchitem = () => {
  //   let flag = true;
  //   const search = this.state.searchShip;
  //   if (search.shipName == '' || search.client == '' || search.imoNo=="" || search.ServiceTypes=='' || )
  // }

  // SearchMMPLData1(pgno, noof) {
  //   const { dispatch } = this.props;
  //   const { searchShip, selectedServiceTypes } = this.state;
  //   searchShip["noofrecords"] = noof;
  //   searchShip["pagenumber"] = pgno;
  //   searchShip.ServiceTypes = selectedServiceTypes.join(",");
  //   this.setState(
  //     {
  //       searchShip: searchShip,
  //       filterShiplist: true,
  //     },
  //     () => {
  //       dispatch({ type: "searchData", data: this.state.searchShip });
  //       dispatch(getShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth));
  //       this.setState({});
  //     }
  //   );
  // }

  handleSelectChange(item) {
    this.state.selectedServiceTypes = item;
    this.setState({})

  };

  handleRemoveChange(item) {
    this.setState({ selectedServiceTypes: item });
  }

  ClearSearchField(type) {

    const { dispatch } = this.props;
    this.setState((prevState) => ({
      searchShip: {
        ...prevState.searchShip, // Preserve previous state values
        IsClient: false,
        shipName: "",
        category: "",
        imoNo: "",
        client: "",
        serviceStatus: "",
        nextServiceDateFrom: "",
        nextServiceDateTo: "",
        pagesize: 25,
        pagenumber: 1,
        noofrecords: 2,
        ServiceTypes: [],
        action: 1,
        status: "active"
      },
      EquipmentName: "",
      selectedServiceTypes: [],
    }), () => {
      if (type !== "cardClick") {
        this.setState((prevstate) => ({
          searchShip: {
            ...prevstate.searchShip,
            isOverdueShips: false,
            isShipsDue10: false,
            isShipsDue30: false,
            isShipsDue60: false,
            isShipsDue90: false,
            isShipSearch: false,
            isShoreSearch: false,
          }
        }))
        dispatch({ type: "searchData", data: "" });
        dispatch(getShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth, true));
      }
    });

    this.multiSelectRef.current.resetSelectedValues()
    // }
  }

  getMapInfo = (contract, both) => {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let url = `${API.MapData}?isClient=${this.state.shipData.IsClient}&mail=${user.email}&inContract=${contract}&isBoth=${both}&isInContract=${this.state.searchShip.FilterByIsInContract}`;
    axios
      .get(url)
      .then((response) => {
        this.bindvalues(response.data);
      })
      .catch((error) => {
        //console.log(error);
      });
  };
  /* Client list get api */

  getClientList = () => {
    let url = `${API.Clientlist}`;
    axios
      .get(url)
      .then((response) => {
        this.state.clientList = response.data.clients;
        this.setState({})
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*  getPortInfo = () => {
       var typeData=[];
   let url = `${API.getPortType}`;
    axios
      .get(url)
      .then((response) => {
       typeData=response.data;
      })
      .catch((error) => {
        console.log(error);
      });
      let url1 = `${API.getPortTypeList}`;
      axios
        .get(url1)
        .then((res) => {
         this.setState({portValue:res.data})
        })
        .catch((error) => {
          console.log(error);
        });
        typeData.map((item,index)=>{
          let filteredItem =this.state.portValue.filter(x=>x.porttype===item)
       this.setState({originalPortData:originalPortData.push(filteredItem)}) 
         this.state.originalPortData[`${item}`].push(filteredItem);
        })
        this.setState({}) 
         }; */

  bindvalues = (data) => {
    const { action } = this.state;
    if (data.length !== 0) {
      let marker = [];
      data.map((item) => {
        if (action === 1) {
          if (item.isOverdue === true) {
            marker.push({
              ...item,
              markerColor: "#FF0000",
            });
          } else if (item.in10Days === true) {
            marker.push({
              ...item,
              markerColor: "#FF5000",
            });
          } else if (item.in30Days === true) {
            marker.push({
              ...item,
              markerColor: "#FF825A",
            });
          } else if (item.in60Days === true) {
            marker.push({
              ...item,
              markerColor: "#FFA500",
            });
          } else if (item.in90Days === true) {
            marker.push({
              ...item,
              markerColor: "#FFE000",
            });
          } else if (
            item.isOverdue === false &&
            item.in10Days === false &&
            item.in30Days === false &&
            item.in60Days === false &&
            item.in90Days === false
          ) {
            marker.push({
              ...item,
              markerColor: "#008800",
            });
          }
        } else if (action === 2 && item.isOverdue === true) {
          marker.push({
            ...item,
            markerColor: "#FF0000",
          });
        } else if (action === 3 && item.in10Days === true) {
          marker.push({
            ...item,
            markerColor: "#FF5000",
          });
        } else if (action === 4 && item.in30Days === true) {
          marker.push({
            ...item,
            markerColor: "#FF825A",
          });
        } else if (action === 5 && item.in60Days === true) {
          marker.push({
            ...item,
            markerColor: "#FFA500",
          });
        } else if (action === 6 && item.in90Days === true) {
          marker.push({
            ...item,
            markerColor: "#FFE000",
          });
        } else {
          if (item.isOverdue === true) {
            marker.push({
              ...item,
              markerColor: "#FF0000",
            });
          } else if (item.in10Days === true) {
            marker.push({
              ...item,
              markerColor: "#FF5000",
            });
          } else if (item.in30Days === true) {
            marker.push({
              ...item,
              markerColor: "#FF825A",
            });
          } else if (item.in60Days === true) {
            marker.push({
              ...item,
              markerColor: "#FFA500",
            });
          } else if (item.in90Days === true) {
            marker.push({
              ...item,
              markerColor: "#FFE000",
            });
          } else if (
            item.isOverdue === false &&
            item.in10Days === false &&
            item.in30Days === false &&
            item.in60Days === false &&
            item.in90Days === false
          ) {
            marker.push({
              ...item,
              markerColor: "#008800",
            });
          }
        }
      });
      if (action === 1) {
        marker = marker;
      } else if (action === 2) {
        marker = marker.filter((x) => x.isOverdue === true);
      } else if (action === 3) {
        marker = marker.filter((x) => x.in10Days === true);
      } else if (action === 4) {
        marker = marker.filter((x) => x.in30Days === true);
      } else if (action === 5) {
        marker = marker.filter((x) => x.in60Days === true);
      } else if (action === 6) {
        marker = marker.filter((x) => x.in90Days === true);
      } else {
        marker = marker;
        console.log(marker, 'markervalues')
      }
      this.setState({ markers: marker });
      //console.log("Data", this.state.markers);
    } else {
      this.setState({ markers: [] });
    }
  };

  /* handleEquipmentSelectChange(value, field, id, fieldId) {
    let param = { ...this.state.searchEquipment, ...{ equipment: value.equipment } }
    if (value.equipment)
    this.props.dispatch(getShipEquipmentSearchlist(param, false, true));
    
    {
        equipmentServicePlanId: 0, // uniques identifier
        shipId: 0,
        shipEquipmentId: 0,
        serviceType: null, //string,
        nextServicePerformedBy: null, //string,
        nextDue: "", // date
        portId: 0,
        port: null, //string,
        countryId: 0,
        country: null, //string,
        comments: null, //string
      }
    
    this.state.equipmentServiceDetails[field] = value;
    this.state.equipmentServiceDetails[fieldId] = id;
    this.setState({});
    let data = {
      port: this.state.equipmentServiceDetails.port,
      country: this.state.equipmentServiceDetails.country,
      serviceProvider: this.state.equipmentServiceDetails.lastDoneServiceProvider,
    };
    this.props.dispatch(getShipPortAndCountry(data));
  }*/

  initiateSummerNote = () => {
    this.state.tabs.forEach(x => {
      $(`#summernote${x.unique_id}`).summernote({
        callbacks: {
          onInit: function () {
            var thisNote = $(this);
            if (thisNote.closest(".modal").length > 0) {
              thisNote.next().find(".dropdown-toggle").dropdown();
            }
          },
          onPaste: function (e) {
            var bufferText = (
              (e.originalEvent || e).clipboardData || window.clipboardData
            ).getData("text/html");
            e.preventDefault();
            var div = $("<div />");
            div.append(bufferText);
            div.find("*").each(function () {
              $(this).css("font-size", "12px");
              $(this).css("font-family", "Arial");
            });
            setTimeout(function () {
              document.execCommand("insertHtml", false, div.html());
            }, 10);
          },
        },
        tabsize: 2,
        height: "450px",
        fontSize: "12px",
        fontFamily: "Arial",
        toolbar: [
          ["style", ["style"]],
          ["font", ["bold", "underline", "clear"]],
          ["color", ["color"]],
          ["fontname", ["fontname"]],
          ["para", ["ul", "ol", "paragraph"]],
          ['table', ['table']],
          ['insert', ['picture']],
        ],
      });
      $(`#summernote${x.unique_id}`).css("font-size", "12px");
      $(`#summernote${x.unique_id}`).css("font-family", "Arial");
      $(`#summernote${x.unique_id}`).summernote('code', x.summernoteData);
    })

    $(".note-editable").css("font-size", "12px");
    $(".note-editable").css("font-family", "Arial");
    $(".close").attr("data-bs-dismiss", "modal");
    if ($('#noteTab .nav-link.active').length == 0)
      this.makeLastTabActive();
  }

  getShipNotes = () => {
    let shipNoteGetUrl = `${API.shipNotes}?shipId=${this.state.equipmentServiceShipId}`;
    let _tabs = [
      {
        tabName: "New",
        unique_id: `new1${(Math.random() + 1).toString(36).substring(7)}`,
        summernoteData: "",
        showInput: false
      }
    ]
    axios
      .get(shipNoteGetUrl)
      .then((response) => {
        if (response?.data?.shipNotes.length > 0) {
          _tabs = response.data.shipNotes.map(x => {
            return {
              tabName: x.name,
              unique_id: `new1${(Math.random() + 1).toString(36).substring(7)}`,
              summernoteData: x.data,
              showInput: false,
              tabId: x.tabId
            }
          });
        }
        this.setState({
          tabs: _tabs,
          initialTabs: _tabs
        }, () => this.initiateSummerNote());
      })
      .catch((error) => {
        console.log(error);
      });
  }

  postNotesData = () => {
    let data = this.getSummerNoteData();
    let user = JSON.parse(localStorage.getItem("currentUser"));
    const _meta = {
      actionBy: user.email,
      shipId: this.state.equipmentServiceShipId,
      shipNotes: data.map(x => {
        return {
          tabId: x.tabId || 0, // 0 for creation
          name: x.tabName,
          data: x.summernoteData,
          dataDescription: x.summernoteData
        }
      })
    }
    let url = API.shipNotes;
    axios
      .post(url, _meta, {
        headers: {
          key: user.accessToken,
        },
      })
      .then((response) => {
        this.setState({
          initialTabs: data
        })
        toast.success(`Ship note added!`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // $('.planning-modal-lg').modal("toggle");
        // $(".modal-backdrop").remove();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to add ship note.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  }

  addTab = () => {
    let tabs = this.state.tabs;
    let uni_id = `new${(Math.random() + 1).toString(36).substring(7)}`
    tabs = this.getSummerNoteData();
    tabs.push({
      tabName: `New`,
      unique_id: uni_id,
      summernoteData: "",
      showInput: false
    });
    this.setState({
      tabs: tabs
    }, () => this.initiateSummerNote())
  }

  handleInputBoxShow = (uniqueId, isShow) => {
    let tabs = this.state.tabs;
    let index = tabs.findIndex(x => x.unique_id == uniqueId);
    let item = tabs[index];
    item.showInput = isShow;
    tabs[index] = item;
    this.setState({
      tabs: tabs
    })
  }

  handleTabName = (e, uniqueId) => {
    let _tabs = this.state.tabs;
    let index = _tabs.findIndex(x => x.unique_id == uniqueId);
    let item = _tabs[index];
    item.tabName = e.target.value;
    _tabs[index] = item;
    this.setState({
      tabs: _tabs
    })
  }

  triggerDeleteConfirmationModel = (uniqueId, tabId) => {
    $('#delete-confirmation-modal').modal("toggle");
    this.setState({
      deleteTabId: tabId || 0,
      deleteUniqueId: uniqueId
    })
  }

  removeTab = (uniqueId, tabId) => {
    let data = this.getSummerNoteData();
    let tabs = data.filter(x => x.unique_id != uniqueId);
    if (tabId) {
      let user = JSON.parse(localStorage.getItem("currentUser"));
      let shipNoteDeleteUrl = `${API.shipNotesDelete}?tabId=${tabId}&actionBy=${user.email}`;
      axios.delete(shipNoteDeleteUrl).then((response) => {
        toast.success(`Ship note deleted!`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }).catch((error) => {
        console.log(error);
        toast.error("Failed to delete ship note.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
    }
    $('#delete-confirmation-modal').modal("toggle");
    // $(".modal-backdrop").remove();
    this.setState({
      tabs: tabs,
    }, () => this.makeLastTabActive())
  }

  getSummerNoteData = () => {
    return this.state.tabs.map(x => {
      return { ...x, 'summernoteData': $(`#summernote${x.unique_id}`).summernote("code") };
    })
  }

  makeLastTabActive = () => {
    $('#noteTab .nav-link').last().addClass("active").attr("aria-selected", "true");
    $(".summernote-wrapper.tab-pane.fade").last().addClass("active show");
  }

  triggerCloseMainModal = (closeClearModel) => {
    if (closeClearModel)
      $('#clear-confirmation-modal').modal("toggle");
    $('.planning-modal-lg').modal("toggle");
    $(".modal-backdrop").remove();
  }

  confirmationModal = () => {
    let data = this.getSummerNoteData();
    let isValid = true;
    if (this.state.initialTabs.length == data.length) {
      let validateArr = [];
      data.forEach((x, i) => {
        validateArr.push(this.comapareObject(this.state.initialTabs[i], x))
      });
      if (validateArr.indexOf(false) > -1)
        isValid = false;
    } else {
      isValid = false;
    }
    if (isValid)
      this.triggerCloseMainModal(false)
    else
      $('#clear-confirmation-modal').modal("toggle");
  }

  comapareObject = (obj1, obj2) => {
    let objEqual = false;
    const obj1Keys = Object.keys(obj1).sort();
    const obj2Keys = Object.keys(obj2).sort();
    if (obj1Keys.length !== obj2Keys.length) {
      return objEqual;
    } else {
      const areEqual = obj1Keys.every((key, index) => {
        const objValue1 = obj1[key];
        const objValue2 = obj2[obj2Keys[index]];
        return objValue1 === objValue2;
      });
      if (areEqual) {
        objEqual = true;
      }
      return objEqual;
    }
  }

  handleSelect = (key) => {
    switch (key) {
      case 'All':
        this.state.currentTab = key;
        this.getShipDetails(1);
        break;
      case 'contract':
        this.state.currentTab = key;
        this.getShipDetails(7, false, false);
        break;
      case 'nonContract':
        this.state.currentTab = key;
        this.getShipDetails(8, false, false);
        break;
      default:
        break;
    }
  };

  render() {
    const {
      t,
      mmplShipCount,
      mmplShipSearchResult,
      mmplShipInfo,
      showMMPLDetailsPane,
      serviceTypeList,
      /* EquipmentNameList,
      PortList,
      CountryList,
      ServiceProviderPortList */
    } = this.props;
    const {
      isTotalShips,
      FilterByIsInContract,
      isOverdueShips,
      isShipsDue10,
      isShipsDue30,
      isShipsDue60,
      isShipsDue90,
    } = this.state.searchShip;
    //console.log(serviceTypeList)
    return (
      <div className="full-height">
        {/* <div className="custom-tabs">
          <div
            className={`custom-tab ${isTotalShips ? 'selected' : ''}`}
            onClick={() => this.getShipDetails(1)}
          >
            All
          </div>
          <div
            className={`custom-tab ${FilterByIsInContract == true ? 'selected' : ''}`}
            onClick={() => this.getShipDetails(7, false, false)}
          >
            Contract
          </div>
          <div
            className={`custom-tab ${FilterByIsInContract == false && !isTotalShips ? 'selected' : ''}`}
            onClick={() => this.getShipDetails(8, false, false)}
          >
            Non Contract
          </div>
        </div> */}
        {/* <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="nav-link active" href="#">All</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Contract</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Non Contract</a>
          </li>
        </ul> */}
        {/* <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="custom-tab custom-active" href="#" id="allTab">All</a>
          </li>
          <li class="nav-item">
            <a class="custom-tab" href="#" id="contractTab">Contract</a>
          </li>
          <li class="nav-item">
            <a class="custom-tab" href="#" id="nonContractTab">Non Contract</a>
          </li>
        </ul> */}

        <div className="custom-tab-container">
          <Tabs activeKey={this.state.currentTab} id="noanim-tab-example" onSelect={this.handleSelect}>
            <Tab eventKey="All" title={t('ContractContent.All')}>
            </Tab>
            <Tab eventKey="contract" title={t('ShipManagementContent.Contract')}>
            </Tab>
            <Tab eventKey="nonContract" title={t('ContractContent.NotContract')} >
            </Tab>
          </Tabs>
        </div>

        <div className="row countcard-row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div className="row h-100">

              <div className={showMMPLDetailsPane ? "col-lg-2" : "col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 countcard-spaceright"}>
                <div
                  className={`${isTotalShips ? "active " : ""
                    }card card-selector countcard-dashboard mb2 p-2 text-center`}
                  onClick={() => this.selectGetShipDetails()}
                >
                  <div className="row g-0 h-100">
                    <div className="col-12 d-flex align-items-center">
                      <div className="w-100">
                        <h1>
                          <CountUp
                            start={0}
                            // end={mmplShipCount.total ? mmplShipCount.total : 0}
                            // end={isTotalShips ? mmplShipCount.total : FilterByIsInContract == true ? mmplShipCount.contract.total : FilterByIsInContract == false && FilterByIsInContract !== '' ? mmplShipCount.nonContract.total : mmplShipCount.total}
                            end={FilterByIsInContract == true ? mmplShipCount.contract.total : FilterByIsInContract == false && FilterByIsInContract !== '' ? mmplShipCount.nonContract.total : mmplShipCount.total}
                            duration={2.0}
                            separator=","
                          />
                        </h1>
                        {showMMPLDetailsPane /* ? (
                <h6 className="text-center">Total Ships</h6>
              ) : (
                <h5 className="text-center">Total Ships</h5>
              )} */
                          ? (
                            <>
                              <h6 className="text-center">{t("content.totalship")}</h6>
                              {/* <h6 className="text-center">Contract</h6> */}
                            </>
                          ) : (
                            <>
                              <h5 className="text-center">{t("content.totalship")}</h5>
                              {/* <h6 className="text-center">Contract</h6> */}
                            </>
                          )}
                      </div>
                    </div>
                    {/* <div className="col-6" onClick={() => this.getShipDetails(1)}> */}
                    {/* <h1>
                    <CountUp
                      start={0}
                      end={mmplShipCount.total ? mmplShipCount.total : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h1> */}
                    {showMMPLDetailsPane
                      /* ? (
                    <h6 className="text-center">Total Ships</h6>
                  ) : (
                    <h5 className="text-center">Total Ships</h5>
                  )} */
                      // ? (<>
                      //   <h6 className="text-center">{t("content.totalship")}</h6>
                      //   <h6 className="text-center">Non Contract</h6>
                      // </>
                      // ) : (
                      //   <>
                      //     <h5 className="text-center">{t("content.totalship")}</h5>
                      //     <h6 className="text-center">Non Contract</h6>
                      //   </>
                      // )
                    }
                    {/* </div> */}
                  </div>
                </div>
              </div>

              {/* <div className={showMMPLDetailsPane ? "col-lg-4" : "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 countcard-spaceright"}>
                <div
                  className={`${FilterByIsInContract == true ? "active " : ""
                    }card card-selector countcard-dashboard mb2 p-2 text-center pointer-default`}
                >
                  <h3 style={{ color: "rgb(255, 0, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(7, false, false)}>
                    <CountUp
                      start={0}
                      end={mmplShipCount.contract?.total ? mmplShipCount.contract?.total : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h3>
                  {showMMPLDetailsPane 
                    ? (
                      <h6 className="text-center mb-0">{t("content.contractShips")}</h6>
                    ) : (
                      <h6 className="text-center mb-0">{t("content.contractShips")}</h6>
                    )}
                  <div className="row mt-2 countcard-shipshore">
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 0, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.contract?.ship ? mmplShipCount.contract?.ship : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(7, true, false)}>{t("content.ship")}{" "}</h6>
                    </div>
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 0, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.contract?.shore ? mmplShipCount.contract?.shore : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(7, false, true)}>{t("content.shore")}{" "}</h6>
                    </div>
                  </div>
                </div>
              </div>

              <div className={showMMPLDetailsPane ? "col-lg-4" : "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 countcard-spaceright"}>
                <div
                  className={`${FilterByIsInContract == false ? "active " : ""
                    }card card-selector countcard-dashboard mb2 p-2 text-center pointer-default`}
                >
                  <h3 style={{ color: "rgb(255, 0, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(8, false, false)}>
                    <CountUp
                      start={0}
                      end={mmplShipCount.nonContract?.total ? mmplShipCount.nonContract?.total : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h3>
                  {showMMPLDetailsPane 
                    ? (
                      <h6 className="text-center mb-0">{t("content.nonContractShips")}</h6>
                    ) : (
                      <h6 className="text-center mb-0">{t("content.nonContractShips")}</h6>
                    )}
                  <div className="row mt-2 countcard-shipshore">
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 0, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.nonContract?.ship ? mmplShipCount.nonContract?.ship : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(8, true, false)}>{t("content.ship")}{" "}</h6>
                    </div>
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 0, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.nonContract?.shore ? mmplShipCount.nonContract?.shore : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(8, false, true)}>{t("content.shore")}{" "}</h6>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className={showMMPLDetailsPane ? "col-lg-2" : "col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 countcard-spaceright"}>
                <div
                  className={`${isOverdueShips ? "active " : ""
                    }card card-selector countcard-dashboard mb2 p-2 text-center pointer-default`}
                >
                  <h3 style={{ color: "rgb(255, 0, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(2, false, false)}>
                    <CountUp
                      start={0}
                      end={mmplShipCount.overDueCount?.total ? mmplShipCount.overDueCount?.total : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h3>
                  {showMMPLDetailsPane /*?  (
                <h6 className="text-center">Overdue Ships</h6>
              ) : (
                <h5 className="text-center">Overdue Ships</h5>
              )} */
                    ? (
                      <h6 className="text-center mb-0">{t("content.overdueship")}</h6>
                    ) : (
                      <h6 className="text-center mb-0">{t("content.overdueship")}</h6>
                    )}
                  <div className="row mt-2 countcard-shipshore">
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 0, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.overDueCount?.ship ? mmplShipCount.overDueCount?.ship : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(2, true, false)}>{t("content.ship")}{" "}</h6>
                    </div>
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 0, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.overDueCount?.shore ? mmplShipCount.overDueCount?.shore : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(2, false, true)}>{t("content.shore")}{" "}</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className={showMMPLDetailsPane ? "col-lg-2" : "col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 countcard-spaceright"}>
                <div
                  className={`${isShipsDue10 ? "active " : ""
                    }card card-selector countcard-dashboard mb2 p-2 text-center pointer-default`}
                >
                  <h3 style={{ color: "rgb(255, 80, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(3, false, false)}>
                    <CountUp
                      start={0}
                      end={mmplShipCount.in10DaysCount?.total ? mmplShipCount.in10DaysCount?.total : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h3>
                  {showMMPLDetailsPane /* ? (
                <h6 className="text-center">Ships Due in 10 Days</h6>
              ) : (
                <h5 className="text-center">Ships Due in 10 Days</h5>
              )} */
                    ? (
                      <h6 className="text-center mb-0">{t("content.10dayship")}</h6>
                    ) : (
                      <h6 className="text-center mb-0">{t("content.10dayship")}</h6>
                    )}
                  <div className="row mt-2 countcard-shipshore">
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 80, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in10DaysCount?.ship ? mmplShipCount.in10DaysCount?.ship : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(3, true, false)}>{t("content.ship")}{" "}</h6>
                    </div>
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 80, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in10DaysCount?.shore ? mmplShipCount.in10DaysCount?.shore : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(3, false, true)}>{t("content.shore")}{" "}</h6>
                    </div>
                  </div>
                </div>
              </div>

              <div className={showMMPLDetailsPane ? "col-lg-2" : "col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 countcard-spaceright"}>
                <div
                  className={`${isShipsDue30 ? "active " : ""
                    }card card-selector countcard-dashboard mb2 p-2 text-center pointer-default`}

                >
                  <h3 style={{ color: "rgb(255, 130, 90)" }} className="pointer-cursor" onClick={() => this.getShipDetails(4, false, false)}>
                    <CountUp
                      start={0}
                      end={mmplShipCount.in30DaysCount?.total ? mmplShipCount.in30DaysCount?.total : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h3>
                  {showMMPLDetailsPane /* ? (
                <h6 className="text-center">Ships Due in 30 Days</h6>
              ) : (
                <h5 className="text-center">Ships Due in 30 Days</h5>
              )} */
                    ? (
                      <h6 className="text-center mb-0">{t("content.30dayship")}</h6>
                    ) : (
                      <h6 className="text-center mb-0">{t("content.30dayship")}</h6>
                    )}
                  <div className="row mt-2 countcard-shipshore">
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 130, 90)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in30DaysCount?.ship ? mmplShipCount.in30DaysCount?.ship : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(4, true, false)}>{t("content.ship")}{" "}</h6>
                    </div>
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 130, 90)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in30DaysCount?.shore ? mmplShipCount.in30DaysCount?.shore : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(4, false, true)}>{t("content.shore")}{" "}</h6>
                    </div>
                  </div>
                </div>
              </div>

              <div className={showMMPLDetailsPane ? "col-lg-2" : "col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 countcard-spaceright"}>
                <div
                  className={`${isShipsDue60 ? "active " : ""
                    }card card-selector countcard-dashboard mb2 p-2 text-center pointer-default`}
                >
                  <h3 className="pointer-cursor" style={{ color: "rgb(255, 165, 0)" }} onClick={() => this.getShipDetails(5, false, false)}>
                    <CountUp
                      start={0}
                      end={mmplShipCount.in60DaysCount?.total ? mmplShipCount.in60DaysCount?.total : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h3>
                  {showMMPLDetailsPane /* ? (
                <h6 className="text-center">Ships Due in 60 Days</h6>
              ) : (
                <h5 className="text-center">Ships Due in 60 Days</h5>
              )} */
                    ? (
                      <h6 className="text-center mb-0">{t("content.60dayship")}</h6>
                    ) : (
                      <h6 className="text-center mb-0">{t("content.60dayship")}</h6>
                    )}
                  <div className="row mt-2 countcard-shipshore">
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 165, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in60DaysCount?.ship ? mmplShipCount.in60DaysCount?.ship : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(5, true, false)}>{t("content.ship")}{" "}</h6>
                    </div>
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 165, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in60DaysCount?.shore ? mmplShipCount.in60DaysCount?.shore : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(5, false, true)}>{t("content.shore")}{" "}</h6>
                    </div>
                  </div>
                </div>
              </div>

              <div className={showMMPLDetailsPane ? "col-lg-2" : "col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2 countcard-spaceright"}>
                <div
                  className={`${isShipsDue90 ? "active " : ""
                    }card card-selector countcard-dashboard mb2 p-2 text-center pointer-default`}
                >
                  <h3 style={{ color: "rgb(255, 224, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(6, false, false)}>
                    <CountUp
                      start={0}
                      end={mmplShipCount.in90DaysCount?.total ? mmplShipCount.in90DaysCount?.total : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h3>
                  {showMMPLDetailsPane /* ? (
                <h6 className="text-center">Ships Due in 90 Days</h6>
              ) : (
                <h5 className="text-center">Ships Due in 90 Days</h5>
              )} */
                    ? (
                      <h6 className="text-center mb-0">{t('content.90dayship')}</h6>
                    ) : (
                      <h6 className="text-center mb-0">{t('content.90dayship')}</h6>
                    )}
                  <div className="row mt-2 countcard-shipshore">
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 224, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in90DaysCount?.ship ? mmplShipCount.in90DaysCount?.ship : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(6, true, false)}>{t("content.ship")}{" "}</h6>
                    </div>
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 224, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in90DaysCount?.shore ? mmplShipCount.in90DaysCount?.shore : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(6, false, true)}>{t("content.shore")}{" "}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
            <div className="row h-100">
              {/* <div className={showMMPLDetailsPane ? "col-lg-4" : "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 countcard-spaceright"}>
                <div
                  className={`${isShipsDue10 ? "active " : ""
                    }card card-selector countcard-dashboard mb2 p-2 text-center pointer-default`}
                >
                  <h3 style={{ color: "rgb(255, 80, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(3, false, false)}>
                    <CountUp
                      start={0}
                      end={mmplShipCount.in10DaysCount?.total ? mmplShipCount.in10DaysCount?.total : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h3>
                  {showMMPLDetailsPane 
                    ? (
                      <h6 className="text-center mb-0">{t("content.10dayship")}</h6>
                    ) : (
                      <h6 className="text-center mb-0">{t("content.10dayship")}</h6>
                    )}
                  <div className="row mt-2 countcard-shipshore">
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 80, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in10DaysCount?.ship ? mmplShipCount.in10DaysCount?.ship : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(3, true, false)}>{t("content.ship")}{" "}</h6>
                    </div>
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 80, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in10DaysCount?.shore ? mmplShipCount.in10DaysCount?.shore : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(3, false, true)}>{t("content.shore")}{" "}</h6>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* <div className={showMMPLDetailsPane ? "col-lg-4" : "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 countcard-spaceright"}>
                <div
                  className={`${isShipsDue30 ? "active " : ""
                    }card card-selector countcard-dashboard mb2 p-2 text-center pointer-default`}

                >
                  <h3 style={{ color: "rgb(255, 130, 90)" }} className="pointer-cursor" onClick={() => this.getShipDetails(4, false, false)}>
                    <CountUp
                      start={0}
                      end={mmplShipCount.in30DaysCount?.total ? mmplShipCount.in30DaysCount?.total : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h3>
                  {showMMPLDetailsPane
                    ? (
                      <h6 className="text-center mb-0">{t("content.30dayship")}</h6>
                    ) : (
                      <h6 className="text-center mb-0">{t("content.30dayship")}</h6>
                    )}
                  <div className="row mt-2 countcard-shipshore">
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 130, 90)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in30DaysCount?.ship ? mmplShipCount.in30DaysCount?.ship : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(4, true, false)}>{t("content.ship")}{" "}</h6>
                    </div>
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 130, 90)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in30DaysCount?.shore ? mmplShipCount.in30DaysCount?.shore : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(4, false, true)}>{t("content.shore")}{" "}</h6>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* <div className={showMMPLDetailsPane ? "col-lg-4" : "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 countcard-spaceright"}>
                <div
                  className={`${isShipsDue60 ? "active " : ""
                    }card card-selector countcard-dashboard mb2 p-2 text-center pointer-default`}
                >
                  <h3 className="pointer-cursor" style={{ color: "rgb(255, 165, 0)" }} onClick={() => this.getShipDetails(5, false, false)}>
                    <CountUp
                      start={0}
                      end={mmplShipCount.in60DaysCount?.total ? mmplShipCount.in60DaysCount?.total : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h3>
                  {showMMPLDetailsPane
                    ? (
                      <h6 className="text-center mb-0">{t("content.60dayship")}</h6>
                    ) : (
                      <h6 className="text-center mb-0">{t("content.60dayship")}</h6>
                    )}
                  <div className="row mt-2 countcard-shipshore">
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 165, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in60DaysCount?.ship ? mmplShipCount.in60DaysCount?.ship : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(5, true, false)}>{t("content.ship")}{" "}</h6>
                    </div>
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 165, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in60DaysCount?.shore ? mmplShipCount.in60DaysCount?.shore : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(5, false, true)}>{t("content.shore")}{" "}</h6>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* <div className={showMMPLDetailsPane ? "col-lg-4" : "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 countcard-spaceright"}>
                <div
                  className={`${isShipsDue90 ? "active " : ""
                    }card card-selector countcard-dashboard mb2 p-2 text-center pointer-default`}
                >
                  <h3 style={{ color: "rgb(255, 224, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(6, false, false)}>
                    <CountUp
                      start={0}
                      end={mmplShipCount.in90DaysCount?.total ? mmplShipCount.in90DaysCount?.total : 0}
                      duration={2.0}
                      separator=","
                    />
                  </h3>
                  {showMMPLDetailsPane
                    ? (
                      <h6 className="text-center mb-0">{t('content.90dayship')}</h6>
                    ) : (
                      <h6 className="text-center mb-0">{t('content.90dayship')}</h6>
                    )}
                  <div className="row mt-2 countcard-shipshore">
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 224, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in90DaysCount?.ship ? mmplShipCount.in90DaysCount?.ship : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(6, true, false)}>{t("content.ship")}{" "}</h6>
                    </div>
                    <div className="col-6">
                      <span style={{ color: "rgb(255, 224, 0)" }}>
                        <CountUp
                          start={0}
                          end={mmplShipCount.in90DaysCount?.shore ? mmplShipCount.in90DaysCount?.shore : 0}
                          duration={2.0}
                          separator=","
                        />
                      </span>
                      <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(6, false, true)}>{t("content.shore")}{" "}</h6>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        {userrole === "admin" || userrole === "mmpl" ? (
          <div className="row mt-2">
            <div className="col-lg-12">
              <div className="panel-box1">
                <div
                  className="card mb-2"
                  style={{ backgroundColor: "white", border: "0px" }}
                >
                  <div className="card-body">
                    <h5
                      className="card-title ml-2 mt-1 cardmarg"
                      style={{ color: "092a51" }}
                    >
                      {this.state.filterTitle === "All Ships" ? `${t("content.Allships")}` : this.state.filterTitle === "Contract Ships" ? `${t("content.contractShips")}` : this.state.filterTitle === "Non Contract Ships" ? `${t("content.nonContractShips")}` : this.state.filterTitle === "Overdue Ships" ? `${t("content.overdueship")}` : this.state.filterTitle === "Ships Due in 10 Days" ? `${t("content.10dayship")}` : this.state.filterTitle === "Ships Due in 30 Days" ?
                        `${t("content.30dayship")}` : this.state.filterTitle === "Ships Due in 60 Days" ? `${t("content.60dayship")}` : this.state.filterTitle === "Ships Due in 90 Days" ? `${t('content.90dayship')}` : ""}
                    </h5>
                  </div>
                </div>
                <div
                  id="map"
                  style={{
                    height: "400px",
                    overflow: "auto",
                    position: "relative",
                  }}
                >
                  <MapCharts markers={this.state.markers} />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {/*  {this.state.portValue?.length!=0?(
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card MM-card-header"
                style={{ backgroundColor: "white", border: "0px" }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    Type of Ports
                  </h5>
                </div>
              </div>
              <div className="search-filter-box">
                 {this.state.originalData &&this.state.originalData ?.length != 0  
      ?this.state.originalData?.map((item, index) => {
        return(
                <div className="p-2">
                  <div className="card">
                    <div className="ml-2 mt-2">
                      <h5 className="resource-list-title m-0">
                        HUB Ports  {item.porttype} 
                      </h5>
                    </div>
                    <div className="search-filter-box">
                      {item.data?.length != 0 ? (
                        item.data.map((item1, index1) => {
                          return (
                            <div className="row py-1">
                              <div className="col7" style={{ paddingLeft: 15 }}>
                                {1}. {index1+1}. 
                              </div>
                              <div className="col-sm-11 p-0">
                                <span>
                                  No. Of ships arriving @ Panama
                                  {item1.port}  (With pending services):
                                  6  {item1.totalshipcount} (2)
                                  {item1.overdueshipcount} {" "}
                                </span>
                              </div>
                            </div>
                         );
                        })
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>

                   ) 
              }): (
                  <div
                    style={{
                      overflow: "hidden",
                      position: "relative",
                      textAlign: "center",
                    }}
                  >
                    <h6 className="resource-list-title no-item-card">
                      No Ports to Display
                    </h6>
                  </div>
                )} 
              </div>
            </div>
          </div>
        </div>
        )
        :(<></>) 
         }  */}
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card MM-card-header"
                style={{ backgroundColor: "white", border: "0px" }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    {this.state.filterTitle === "All Ships" ? `${t("content.Allships")}` : this.state.filterTitle === "Overdue Ships" ? `${t("content.overdueship")}` : this.state.filterTitle === "Ships Due in 10 Days" ? `${t("content.10dayship")}` : this.state.filterTitle === "Ships Due in 30 Days" ?
                      `${t("content.30dayship")}` : this.state.filterTitle === "Ships Due in 60 Days" ? `${t("content.60dayship")}` : this.state.filterTitle === "Ships Due in 90 Days" ? `${t('content.90dayship')}` : ""}
                  </h5>
                </div>
              </div>
              <div className="search-filter-box">
                <div className="row">
                  <div
                    className={showMMPLDetailsPane ? "col-lg-6 " : "col-lg-4 "}
                  >
                    {/*  <label className="form-label">Ship Name</label> */}
                    <label className="form-label">{t('content.Shipname')}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="shipName"
                      onChange={(e) => this.handleInputChange(e)}
                      /*  value={
                         localStorage.getItem("SelectedLanguage") === "ko"
                           ? this.state.searchShipKorean.shipName
                           : localStorage.getItem("SelectedLanguage") === "ja"
                           ? this.state.searchShipJapanese.shipName
                           : this.state.searchShip.shipName
                       } */
                      value={this.state.searchShip.shipName}
                      /* placeholder="Ship Name" */
                      placeholder={t('content.Shipname')}
                    ></input>
                    {/* <AutoComplete value={this.state.shipName} onChange={(e) => this.handleInputChange(e)}
                      suggestions={this.state.EquipmentList} completeMethod={this.suggestMItable.bind(this)}
                      name="shipName" inputClassName="form-control" placeholder="Ship Name" style={{ display: 'block' }}
                      inputStyle={!showMMPLDetailsPane ? { borderColor: "#ced4da", height: "38px" } : { borderColor: "#ced4da", width: '270.75px', height: '38px' }} /> */}
                  </div>
                  <div
                    className={showMMPLDetailsPane ? "col-lg-6 " : "col-lg-4 "}
                  >
                    <label className="form-label">{t('content.Client')}</label>
                    {/*  <label className="form-label">Client</label> */}
                    <br></br>
                    <Autocomplete
                      id="clientnameplaceholder"
                      value={this.state.searchShip.client}
                      options={this.state.clientList}
                      getOptionLabel={(option) => option || ""}
                      onChange={(event, value) => {
                        this.handleChangeClientName(event, value);
                      }}
                      noOptionsText={"No options to display"}
                      freeSolo={false}
                      disableClearable
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className="form-control "
                          id="margin-dense"
                          style={{ marginTop: -1 }}
                          margin="dense"
                          size="small"
                          variant="outlined"
                          placeholder={t('content.Client')}
                        // sx={{
                        //   '& .MuiInputBase-input::placeholder': {
                        //     color: 'red !important',  
                        //     opacity: 1      
                        //   }
                        // }}
                        // InputProps={{
                        //   // Change input text color
                        //   inputProps: {
                        //     style: { color: 'black', opacity: 1 }, // Change placeholder color
                        //   },
                        // }}
                        />
                      )}
                    />
                  </div>
                  <div
                    className={showMMPLDetailsPane ? "col-lg-6 " : "col-lg-4 "}
                  >
                    {/* <label className="form-label">IMO No</label> */}
                    <label className="form-label">{t('content.IMOno')}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="imoNo"
                      /*   placeholder="IMO No" */
                      placeholder={t('content.IMOno')}
                      onChange={(e) => this.handleInputChange(e)}
                      value={this.state.searchShip.imoNo}
                    ></input>
                  </div>
                  <div
                    className={showMMPLDetailsPane ? "col-lg-6 " : "col-lg-4 "}
                  >
                    <label className="form-label">{t('content.Servicetype')}</label>
                    {/*  <label className="form-label">Service Type</label> */}
                    <Multiselect options={serviceTypeList ?? []} isObject={false}
                      ref={this.multiSelectRef}
                      style={{ option: { "margin-right": 0, "display": "block", "font-weight": "normal" }, chips: { "background-color": "#1a3464" } }}
                      onSelect={(item) => this.handleSelectChange(item)}
                      onRemove={(item) => this.handleRemoveChange(item)}
                      showArrow={true}
                      selectedValues={this.state.selectedServiceTypes}
                      placeholder={
                        this.state.selectedServiceTypes &&
                          this.state.selectedServiceTypes.length
                          ? ""
                          : `${t('content.Select')}`
                      }
                      closeIcon="cancel"
                    //value={this.state.selectedServiceTypes}
                    />
                    {/* <div className="row">
                      <div className={showMMPLDetailsPane ? "row ml-0" : "col-sm-12 flex flexwrap"}>
                        <div className={showMMPLDetailsPane ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Annual').length != 0 ? true : false) : false} onChange={this.serviceTypeChange.bind(this, 'Annual')}></input>
                          <span className="ml-1">Annual</span>
                        </div>
                        <div className={showMMPLDetailsPane ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Biannual').length != 0 ? true : false) : false} onChange={this.serviceTypeChange.bind(this, 'Biannual')}></input>
                          <span className="ml-1">Biannual</span>
                        </div>
                        <div className={showMMPLDetailsPane ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Five yearly').length != 0 ? true : false) : false} onChange={this.serviceTypeChange.bind(this, 'Five yearly')}></input>
                          <span className="ml-1">Five Yearly</span>
                        </div>
                        <div className={showMMPLDetailsPane ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Ten yearly').length != 0 ? true : false) : false} onChange={this.serviceTypeChange.bind(this, 'Ten yearly')}></input>
                          <span className="ml-1">Ten Yearly</span>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div
                    className={
                      showMMPLDetailsPane
                        ? "col-lg-6  col-sm-12 col-xs-12"
                        : "col-lg-4  col-sm-12 col-xs-12"
                    }
                  >
                    {/* <label className="form-label">Next Due In</label>
                      <br></br> */}
                    <div className="row">
                      <div
                        className={
                          showMMPLDetailsPane ? "col-lg-6" : "col-lg-6"
                        }
                      >
                        <label className="form-label">{t('content.NextDueFrom')}</label>
                        {/*  <label className="form-label">Next Due From</label> */}
                        <div
                          className="input-group add-on date datepicker datezindex"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            type="text"
                            value={this.state.searchShip.nextServiceDateFrom}
                            className="form-control date-picker"
                            /*  placeholder="Next Due From" */
                            placeholder={t('content.NextDueFrom')}
                            name="fromDate"
                          ></input>
                          <DatePicker
                            selected={this.state.SelectedFromDate}

                            onChange={this.handleFromDateChange}
                            open={this.state.fromDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control datezindex date-picker w-5 hide-date"
                          // maxDate={this.state.SelectedToDate}

                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openFromDatePicker}
                          >
                            <button
                              className="btn btn-default"
                              style={{ height: "100%" }}
                            >
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          showMMPLDetailsPane
                            ? "col-lg-6 margin"
                            : "col-lg-6 margin"
                        }
                      >
                        <label className="form-label">{t('content.NextDueTo')}</label>
                        {/*                       <label className="form-label">Next Due To</label> */}
                        <div
                          className="input-group add-on date datepicker datezindex"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            value={this.state.searchShip.nextServiceDateTo}
                            type="text"
                            placeholder={t('content.NextDueTo')}
                            /*placeholder="Next Due To" */
                            className="form-control date-picker"
                            name="toDate"
                            data-date-format="yyyy-mm-dd"
                          />
                          <DatePicker
                            selected={this.state.SelectedToDate}
                            onChange={this.handleToDateChange}
                            open={this.state.toDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker  w-5 hide-date"

                          // minDate={this.state.SelectedFromDate}
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openToDatePicker}
                          >
                            <button className="btn btn-default pt-2">
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div
                    className={
                      showMMPLDetailsPane ? "col-sm-12 mt-4" : "col-lg-12 mt-4"}>
                    <div
                      className="form-group search-btn-col"
                      style={{ textAlign: "end" }}>
                      {/* <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
                        id="popover">
                        {" "}
                        {t('ShipManagementContent.Contract')}{" "}
                      </button> */}

                      {/* <Popover
                        className="popover-master"
                        placement="left"
                        trigger="legacy"
                        isOpen={this.state.isPopoveropen}
                        target={"popover"}
                        toggle={() => this.toggle()}>
                        <PopoverHeader>
                          {t('ShipManagementContent.Contract')}{" "}{t("content.Search")}
                        </PopoverHeader>
                        <PopoverBody>
                          <div className="row">
                            <div className="col-4 my-1 d-flex">
                              <input
                                type="radio"
                                name="incontract"
                                // checked={this.state.inContract}
                                checked={this.state.SelectedRadio === 1}
                                onChange={(e) =>
                                  this.handleRadioButtonChange(e)
                                }
                              />
                              <span className="ml-1">{t("ContractContent.IsContract")}</span>
                            </div>
                            <div className="col-5 my-1 d-flex">
                              <input
                                type="radio"
                                name="notcontract"
                                // checked={this.state.notInContract}
                                checked={this.state.SelectedRadio === 2}
                                onChange={(e) =>
                                  this.handleRadioButtonChange(e)
                                }
                              />
                              <span className="ml-1">{t("ContractContent.NotContract")}</span>
                            </div>
                            <div className="col-3 my-1 d-flex">
                              <input
                                type="radio"
                                name="both"
                                // checked={this.state.isBoth}
                                checked={this.state.SelectedRadio === 0}
                                onChange={(e) =>
                                  this.handleRadioButtonChange(e)
                                }
                              />
                              <span className="ml-1">{t("ContractContent.All")}</span>
                            </div>
                            <div
                              className="col-12 mt-1"
                              style={{ textAlign: "right" }}
                            >
                              <div className="btn-group">
                                <Button
                                  className="btn btn-primary btn-xs mt-2"
                                  size="sm"
                                  onClick={() => this.submitRequest()}
                                >
                                  {t("Generateservicerequestcontent.Request")}
                                </Button>
                              </div>
                            </div>
                          </div>
                        </PopoverBody>
                      </Popover> */}
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3 mt-3"
                        type="submit"
                        onClick={() => this.GenerateReportData(this.state.inContract, this.state.isBoth, this.state.searchShip.FilterByIsInContract)}>
                        {" "}
                        {t('content.GenerateReport')}{" "}
                      </button>

                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3 mt-3"
                        type="submit"
                        onClick={() => this.searchValidate(1, 2, true)}>
                        {" "}
                        {/* Search{" "} */}
                        {t('content.Search')}{" "}
                      </button>

                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3 mt-3"
                        type="button"
                        onClick={() => this.ClearSearchField("clear")}
                      >
                        {" "}
                        {/*    Clear{" "} */}
                        {t('content.Clear')}{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {mmplShipSearchResult ? (
          <MMPLShipCard
            arraylist={mmplShipSearchResult}
            currentPage={(mmplShipSearchResult.pagination.currentPage - 1) * mmplShipSearchResult.pagination.pageSize}
            pageSize={mmplShipSearchResult.pagination.pageSize}
            totalRecords={mmplShipSearchResult.pagination.totalcount ? mmplShipSearchResult.pagination.totalcount : 0}
            setUpdatedState={(value, records) => this.PaginateCard(value, records)}
            shipMMPLInfo={mmplShipInfo}
            isContract={this.state.inContract}
            isBoth={this.state.isBoth}
          />
        ) : null}
        <div
          className="modal fade planning-modal-lg"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          data-backdrop="static"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="full-height container-fluid pt-3">
                <div className="row mt-2">
                  <div className="col-lg-12">
                    <div className="panel-box">
                      <div
                        className="card MM-card-header"
                        style={{ backgroundColor: "white" }}
                      >
                        <div className="card-body">
                          <h5
                            className="card-title ml-2 mt-2"
                            style={{ color: "092a51" }}
                          >
                            {t("TopPaneContent.EquipmentReport")}
                            <button type="button" className="close" onClick={() => this.confirmationModal()} /* data-dismiss="modal" aria-label="Close" aria-hidden="true" data-bs-dismiss="modal" */>×</button>
                          </h5>
                        </div>
                      </div>
                      <div className="search-filter-box">
                        {/* <div className="row">
                          <div
                            className={"col-lg-3"}
                          >
                            <div className="">
                              <label className="form-label">{t("ShipEquipmentStatusScreen.Equipment")}</label>
                              <br></br>
                              <Autocomplete
                                // value={this.state.searchShip.client}
                                options={EquipmentNameList || []}
                                getOptionLabel={(option) => option.equipmentName || ""}
                                onChange={(event, value) => {
                                  this.handleChangeEquipmentName(event, value);
                                }}
                                noOptionsText={"No options to display"}
                                freeSolo={false}
                                disableClearable
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    className="form-control"
                                    id="margin-dense"
                                    style={{ marginTop: -1 }}
                                    margin="dense"
                                    size="small"
                                    variant="outlined"
                                    placeholder={t("ShipEquipmentStatusScreen.Equipment")}
                                  />
                                )}
                              />
                            </div>

                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("ShipDetailsScreen.NextDue")}</label>
                            <br></br>
                            // <div>
                            <input
                              className="form-control"
                              type="text"
                              name="shipName"
                              disabled={true}
                              value={this.state.searchShip.shipName}
                              placeholder={t("ShipDetailsScreen.NextDue")}
                            ></input>
                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("ComplianceandBudgetScreen.Type")}</label>
                            <input
                              className="form-control"
                              type="text"
                              name="type"
                              disabled={true}
                              value={this.state.searchShip.shipName}
                              placeholder={t("ComplianceandBudgetScreen.Type")}
                            ></input>
                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("TopPaneContent.PerformedBy")}</label>
                            <input
                              className="form-control"
                              type="text"
                              name="shipName"
                              disabled={true}
                              value={this.state.searchShip.shipName}
                              placeholder={t("TopPaneContent.PerformedBy")}
                            ></input>
                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("EquipmentServiceTypes.Country")}</label>
                            <Autocomplete
                              // value={this.state.searchShip.client}
                              options={CountryList?.data || []}
                              getOptionLabel={(option) => option.country || ""}
                              // onChange={(event, value) => {
                              //   this.handleChangeClientName(event, value);
                              // }}
                              noOptionsText={"No options to display"}
                              freeSolo={false}
                              disableClearable
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  className="form-control"
                                  id="margin-dense"
                                  style={{ marginTop: -1 }}
                                  margin="dense"
                                  size="small"
                                  variant="outlined"
                                  placeholder={t("EquipmentServiceTypes.Country")}
                                />
                              )}
                            />
                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("TopPaneContent.Port")}</label>
                            <Autocomplete
                              // value={this.state.searchShip.client}
                              options={PortList?.data || []}
                              getOptionLabel={(option) => option.port || ""}
                              // onChange={(event, value) => {
                              //   this.handleChangeClientName(event, value);
                              // }}
                              noOptionsText={"No options to display"}
                              freeSolo={false}
                              disableClearable
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  className="form-control"
                                  id="margin-dense"
                                  style={{ marginTop: -1 }}
                                  margin="dense"
                                  size="small"
                                  variant="outlined"
                                  placeholder={t("TopPaneContent.Port")}
                                />
                              )}
                            />
                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("ShipDetailsScreen.ServiceProvider")}</label>
                            <Autocomplete
                              // value={this.state.searchShip.client}
                              options={ServiceProviderPortList?.data || []}
                              getOptionLabel={(option) => option.serviceProvider || ""}
                              // onChange={(event, value) => {
                              //   this.handleChangeClientName(event, value);
                              // }}
                              noOptionsText={"No options to display"}
                              freeSolo={false}
                              disableClearable
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  className="form-control"
                                  id="margin-dense"
                                  style={{ marginTop: -1 }}
                                  margin="dense"
                                  size="small"
                                  variant="outlined"
                                  placeholder={t("ShipDetailsScreen.ServiceProvider")}
                                />
                              )}
                            />
                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("ShipDetailsScreen.Comments")}</label>
                            <textarea
                              className="form-control"
                              id="comments"
                              name="comments"
                              rows={1}
                            ></textarea>
                          </div>
                        </div> */}
                        <div className="row">
                          <div className="col-12">
                            <div className="equipment-service-note-tab-wrapper">
                              <ul className="nav nav-tabs" id="noteTab" role="tablist">
                                {
                                  this.state.tabs.map((ele, ind) => {
                                    return <li className="nav-item" role="presentation">
                                      <button
                                        className={`nav-link`}
                                        id={ele.unique_id + '-tab'}
                                        data-toggle="tab"
                                        data-target={`#${ele.unique_id}`}
                                        type="button"
                                        role="tab"
                                        aria-controls={`${ele.unique_id}`}
                                        aria-selected='false'
                                      // onClick={() => this.initiateSummerNote(`${ele.unique_id}`)}
                                      >
                                        {
                                          ele.showInput ? <div className="d-flex">
                                            <input type="text" className="form-control nav-tab-input" autoFocus="true" value={ele.tabName} autoComplete="off" onChange={(e) => this.handleTabName(e, ele.unique_id)}></input>
                                            <img className="nav-tab-input-img" style={{ height: '1.2rem' }} onClick={() => this.handleInputBoxShow(ele.unique_id, false)} src={DoneIcon}></img>
                                            {/* <img className="nav-tab-input-img" style={{ height: '1.4rem' }} src={CloseIcon}></img> */}
                                          </div> :
                                            <span>{ele.tabName == "New" ? `${ele.tabName} ${ind + 1}` : ele.tabName}{" "}</span>
                                        }
                                        {
                                          !ele.showInput ? <i className="fa fa-edit m-1 ml-3" onClick={() => this.handleInputBoxShow(ele.unique_id, true)}></i> : ''
                                        }
                                        <i class="fa fa-times m-1" onClick={() => this.triggerDeleteConfirmationModel(ele.unique_id, ele.tabId)}></i>
                                      </button>
                                    </li>
                                  })
                                }
                                <div className="tab-add" onClick={() => this.addTab()}>
                                  <AddIcon />
                                </div>
                              </ul>
                            </div>

                            <div className="tab-content" id="myTabContent">
                              {
                                this.state.tabs.map((ele, ind) => {
                                  return <div
                                    className={`summernote-wrapper tab-pane fade`}
                                    id={ele.unique_id}
                                    role="tabpanel"
                                    aria-labelledby={`${ele.unique_id}-tab`}
                                  >
                                    <div className="pt-2" id={`summernote${ele.unique_id}`}></div>
                                  </div>
                                })
                              }
                            </div>
                          </div>

                        </div>
                        <div className="row">
                          <div
                            className={"col-sm-12"}
                          >
                            <div
                              className="form-group search-btn-col mt-3"
                              style={{ textAlign: "end" }}
                            >
                              <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                type="submit"
                                onClick={() => this.postNotesData()}
                              >
                                {" "}
                                {t("EditEquipmentScreenContent.Save")}{" "}
                              </button>

                              <button
                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3 close"
                                type="button" /* data-dismiss="modal" aria-label="Close" aria-hidden="true" data-bs-dismiss="modal" */
                                onClick={() => this.confirmationModal()}
                              >
                                {" "}
                                {t("EditEquipmentScreenContent.Close")}{" "}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="panel-box">
                      <div className="search-filter-box">
                        <table className="table equipment-report-table border-0">
                          <thead className="">
                            <tr>
                              <th scope="col">{t("ShipEquipmentStatusScreen.Equipment")}</th>
                              <th scope="col">{t("ShipDetailsScreen.NextDue")}</th>
                              <th scope="col">{t("ComplianceandBudgetScreen.Type")}</th>
                              <th scope="col">{t("TopPaneContent.PerformedBy")}</th>
                              <th scope="col">{t("EquipmentServiceTypes.Country")}</th>
                              <th scope="col">{t("TopPaneContent.Port")}</th>
                              <th scope="col">{t("ShipDetailsScreen.ServiceProvider")}</th>
                              <th scope="col" style={{ width: "30%" }}>{t("ShipDetailsScreen.Comments")}</th>
                              <th scope="col">{t("VendorManagementScreenContent.Action")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Alcohol Meter</td>
                              <td>29 Sep 2024</td>
                              <td>1 yearly</td>
                              <td>Ship</td>
                              <td>Okha</td>
                              <td>India</td>
                              <td>Ask marine service</td>
                              <td>He made his comments at a news conference in Amsterdam.</td>
                              <td><div className="text-center">
                                <i
                                  className="fa fa-edit fa-lg click m-1 px-1"
                                  // onClick={() =>
                                  //   this.showFlagModal(
                                  //     item.Id,
                                  //     false,
                                  //     item.equipmentId
                                  //   )
                                  // }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                                <i
                                  className="fa fa-trash click m-1 px-2"
                                  // onClick={() =>
                                  //   this.deleteApplicableType(index)
                                  // }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                              </div></td>
                            </tr>
                            <tr>
                              <td>Breathing Air Compressor (Air Quality Check)</td>
                              <td>11 Sep 2024</td>
                              <td>4 yearly</td>
                              <td>Shore</td>
                              <td>Okha</td>
                              <td>India</td>
                              <td>Ask marine service</td>
                              <td>I was wondering whether you had any comments about that?</td>
                              <td><div className="text-center">
                                <i
                                  className="fa fa-edit fa-lg click m-1 px-1"
                                  // onClick={() =>
                                  //   this.showFlagModal(
                                  //     item.Id,
                                  //     false,
                                  //     item.equipmentId
                                  //   )
                                  // }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                                <i
                                  className="fa fa-trash click m-1 px-2"
                                  // onClick={() =>
                                  //   this.deleteApplicableType(index)
                                  // }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                              </div></td>
                            </tr>
                            <tr>
                              <td>Emergency Escape Breathing Device</td>
                              <td>11 Sep 2024</td>
                              <td>5 yearly</td>
                              <td>Ship</td>
                              <td>Okha</td>
                              <td>India</td>
                              <td>Ask marine service</td>
                              <td>There's been no comment so far from police about the allegations.</td>
                              <td><div className="text-center">
                                <i
                                  className="fa fa-edit fa-lg click m-1 px-1"
                                  // onClick={() =>
                                  //   this.showFlagModal(
                                  //     item.Id,
                                  //     false,
                                  //     item.equipmentId
                                  //   )
                                  // }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                                <i
                                  className="fa fa-trash click m-1 px-2"
                                  // onClick={() =>
                                  //   this.deleteApplicableType(index)
                                  // }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                              </div></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Delete confirmation model */}
        <div
          className="modal fade"
          id="delete-confirmation-modal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="delete-confirmation-modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="delete-confirmation-modalLabel">
                  {t("CommonText.Delete")}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>{t("confirmAlertMessage.DeleteMsg")}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light text-uppercase txtside-btn txtht-btn"
                  data-dismiss="modal"
                >
                  {t("confirmAlertMessage.No")}
                </button>
                <button type="button" onClick={() => this.removeTab(this.state.deleteUniqueId, this.state.deleteTabId)} className="btn btn-primary text-uppercase txtside-btn txtht-btn blue">
                  {t("confirmAlertMessage.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Clear confirmation modal */}
        <div
          className="modal fade"
          id="clear-confirmation-modal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="clear-confirmation-modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="clear-confirmation-modalLabel">
                  {t("confirmAlertMessage.Warning")}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>{t("confirmAlertMessage.ClearMsg")}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light text-uppercase txtside-btn txtht-btn"
                  data-dismiss="modal"
                >
                  {t("confirmAlertMessage.No")}
                </button>
                <button type="button" onClick={() => this.triggerCloseMainModal(true)} className="btn btn-primary text-uppercase txtside-btn txtht-btn blue">
                  {t("confirmAlertMessage.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>

      </div >
    );
  }
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    materialDeclarationslist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    searchData: state.SidePanReducer.searchData,
    searched: state.SidePanReducer.searched || false,
    ClientShipDetails: state.SidePanReducer.ClientShipDetails,
    //BY BALU MOORTHI
    mmplShipCount: state.MMPLDashboardReducer.MMPLShipCount || {
      total: 0,
      overDue: 0,
      in10Days: 0,
      in30Days: 0,
      in60Days: 0,
      in90Days: 0,
    },
    mmplShipDetail: state.MMPLDashboardReducer.MMPLShipDetail || {},
    mmplShipSearchResult:
      state.MMPLDashboardReducer.MMPLShipSearchResult || null,
    mmplShipInfo: state.MMPLDashboardReducer.MMPLShipInfo || {},
    showMMPLDetailsPane: state.SidePanReducer.ShowMMPLDetailsPane || false,
    serviceTypeList:
      state.MasterScreenReducer.applicableServiceTypeInterval || [],
    SelectedLanguage: state.SidePanReducer.selectedLang,
    PortList: state.MasterScreenReducer.ShipPortList || [],
    CountryList: state.MasterScreenReducer.ShipCountryList || [],
    EquipmentNameList: state.MasterScreenReducer.EquipmentNameList1 || [],
    ServiceProviderPortList: state.MasterScreenReducer.ShipServiceProviderPortList || [],
    shipSearchResult: state.ShipEquipmentReducer.shipSearchResult,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(MMPLDashboard));
//export default connect(mapStateToProps, mapDispatchToProps)(MMPLDashboard);
